import React from "react";

import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";

export default class SelectShotConfirmRow extends React.PureComponent {
  render() {
    const { props } = this;
    const { selectedMenu } = props;

    return (
      <TableRow key={props.id} hover>
        <TableCell>{props.scene}</TableCell>
        <TableCell>{props.description}</TableCell>
        <TableCell>{props.location}</TableCell>
        <TableCell>{props.angle}</TableCell>
        <TableCell>{props.framing}</TableCell>
        {this.props.type === "video" && <TableCell>{props.camera}</TableCell>}
      </TableRow>
    );
  }
}
